import React, { useState, useEffect } from "react";
// import UploadService from "../services/FileUploadService";
// import http from "../http-common";
import Axios from 'axios';
import { MDBProgress,MDBFileInput, MDBRow,MDBCol,MDBBtn,MDBIcon } from 'mdbreact';


const PhotoUpload = (props) => {


  // const uploadNew = (file, onUploadProgress,directivecode) => {
  //   let formData = new FormData();
  
  //   formData.append("file", file);
  //   formData.append("directivecode",directivecode);
  
  //   return http.post("/uploadpdf", formData, {
  //     headers: {
  //       "Content-Type": "multipart/form-data",
  //     },
  //     onUploadProgress,
  //   });
  
  
  // };
  
  const getFiles = () => {
   // return Axios.get(props.apiServer +"/loadattachments?token=asdsadsads");
  };



    const [selectedFiles, setSelectedFiles] = useState(undefined);
    const [currentFile, setCurrentFile] = useState(undefined);
    const [progress, setProgress] = useState(0);
    const [message, setMessage] = useState("");
  
    const [fileInfos, setFileInfos] = useState([]);

    const selectFile = (event) => {
        
        if(event.target.files[0].type === "image/jpeg")
        {
          setSelectedFiles(event.target.files);
          setMessage("");
          return;
        }

        if(event.target.files[0].type === "image/png")
        {
          setSelectedFiles(event.target.files);
          setMessage("");
          return;
        }


        if(event.target.files[0].type === "image/gif")
        {
          setSelectedFiles(event.target.files);
          setMessage("");
          return;
        }

       
          console.log('Not supported');
          setSelectedFiles(undefined);
          setMessage("Invalid type of file!");
  
          return;
       
      };



      const upload = () => {
        let currentFile = selectedFiles[0];
    
        setProgress(0);
        setCurrentFile(currentFile);
    

      //  handleUpload(currentFile, (event) => {
      //     setProgress(Math.round((100 * event.loaded) / event.total));
      //   })
      //     .then((response) => {
      //       setMessage(response.data.message);
      //       // return UploadService.getFiles();
      //       // return getFiles();
      //     })
      //     .then((files) => {
          
      //     })
      //     .catch(() => {
      //       setProgress(0);
      //       setMessage("Could not upload the file!");
      //       setCurrentFile(undefined);
      //     });
    
      //   setSelectedFiles(undefined);
      // };

      handleUpload(currentFile, (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      })
        .then((response) => {
          setMessage(response.data.message);
          // return UploadService.getFiles();
          // return getFiles();
         props.getprofilepic();
         window.location.reload();
          return '';
        })
        .catch(error => {
          setProgress(0);
          setMessage(error);
         
        });
  
      setSelectedFiles(undefined);

    };



      const handleUpload = (file, onUploadProgress) => {
        let formData = new FormData();
      
        formData.append("file", file);
        formData.append("username",props.username);
    
    
        
      return  Axios.post(props.apiServer + "/uploadprofilephoto", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress,
          }).then(setMessage('Upload complete!')); 

         


      
      };


      // useEffect(() => {
      //   UploadService.getFiles().then((response) => {
      //     setFileInfos(response.data);
      //   });
      // }, []);


      return (
        <div>
          {currentFile && (
            <React.Fragment>
               <MDBProgress material color="info" value={progress} striped min={0} max={100} height={"25px"} style={{ width: progress + "%" }} >

                 {progress} &nbsp; %
               </MDBProgress>
            
            
            </React.Fragment>
          )}
    

        <MDBRow>

            <MDBCol md="12">
          
                            <h5><b><span className="red-text">NOTE:</span></b></h5>
                            <p> Recommended size is 350px x 400px (width x height)</p>
                            <p> Only JPEG, PNG and GIF files are allowed to be uploaded.</p>
            <br/>
         

            </MDBCol>

          </MDBRow>
      
          <MDBRow>

            <MDBCol md="12">
          
                            <label>   
                                 <input type="file" onChange={selectFile} 
                                  accept="image/gif, image/jpeg, image/png"
                                 
                                 /> 
                            
                                 </label>   
            
            </MDBCol>

          </MDBRow>
          <MDBRow>

          <MDBCol md="12">
            <h5 className="red-text"> {message}</h5>
           
          </MDBCol>

          </MDBRow>
          <MDBRow>

            <MDBCol md="12">
            <MDBBtn color="info" disabled={!selectedFiles} size="sm"    onClick={upload} >Upload</MDBBtn>
            <MDBBtn className="cloudy-knoxville-gradient blue-text" size="sm" onClick={props.toggleModal}>
                                        Cancel
            </MDBBtn>
            </MDBCol>

          </MDBRow>
         {/* <button
            className="btn btn-success"
            disabled={!selectedFiles}
            onClick={upload}
          >
            Upload
          </button>  */}
    
        
    
          
        </div>
      );
   

  
};

export default PhotoUpload;
